
import { AlarmUiState } from './types'

export const state: AlarmUiState = {
  drawerVisible: false,
}
